module.exports = __webpack_public_path__ + "img/0.1b3c1d3c.png";